import React from "react";
import { useParams } from "react-router";
import { buildFullLink } from "common/routing";
import { getClientAppPrefix } from "common/utils/url";
import { useUserInviteQuery } from "../../generated/graphql";
import { UserInvite } from "./UserInvite";
import { UserInviteAccepted } from "./UserInviteAccepted";
import { UserInviteNotFound } from "./UserInviteNotFound";

const InvitePage = () => {
  const { inviteId } = useParams<{ inviteId: string }>();
  const { data, loading, error } = useUserInviteQuery({
    variables: { inviteId },
  });

  if (error || loading) return null;

  if (!data?.userInvite) {
    return <UserInviteNotFound />;
  }

  if (data.userInvite.acceptedAt) {
    return <UserInviteAccepted />;
  }

  const currentUrl = window.location.href;

  //this is to support legacy user invitation links
  if (!currentUrl.includes(data.userInvite.account.subdomain)) {
    const prefix = getClientAppPrefix(data.userInvite.account.subdomain);
    window.location.href = buildFullLink("acceptInvite", {
      params: { inviteId },
      prefix,
    });
    return null;
  }

  return <UserInvite userInvite={data.userInvite} />;
};

export default InvitePage;
